import { useEffect, useRef } from 'react'
import useDistributor from './useDistributor'

const BASE_URL = 'https://suporte.bonifi.ca'
const WEBSITE_TOKEN = 'JEHJnttoGKBwRmCuUnijdj4b'
const SCRIPT_ID = 'chatwoot-sdk'

export default function useChatwoot() {
    const sdkInitialized = useRef(false)
    const distributor = useDistributor()

    useEffect(() => {
        // useRef guard: React StrictMode monta o componente duas vezes em dev.
        // Sem esse guard, o script seria injetado duas vezes.
        if (sdkInitialized.current) return
        sdkInitialized.current = true

        window.chatwootSettings = {
            position: 'left',
            type: 'expanded_bubble',
            launcherTitle: 'Fale com o suporte',
            hideMessageBubble: true,
        }

        // Reutiliza script já injetado (ex.: HMR em dev ou remount futuro)
        if (document.getElementById(SCRIPT_ID)) {
            if (window.chatwootSDK) {
                window.chatwootSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL })
            }
            return
        }

        const script = document.createElement('script')
        script.id = SCRIPT_ID
        script.src = `${BASE_URL}/packs/js/sdk.js`
        script.async = true
        script.defer = true

        script.onerror = () => console.warn('[Chatwoot] Falha ao carregar o SDK. Verifique a URL:', BASE_URL)

        script.onload = () => {
            if (!window.chatwootSDK) {
                console.warn('[Chatwoot] Script carregado, mas window.chatwootSDK não foi exposto.')
                return
            }
            window.chatwootSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL })
        }

        document.head.appendChild(script)
    }, [])

    useEffect(() => {
        if (!distributor.data) return

        const identify = () => {
            if (!window.$chatwoot) return
            window.$chatwoot.setUser(String(distributor.data.id), {
                name: distributor.data.customer?.name ?? distributor.data.name,
                email: distributor.data.email,
            })
        }

        if (window.$chatwoot) {
            identify()
        } else {
            window.addEventListener('chatwoot:ready', identify, { once: true })
            return () => window.removeEventListener('chatwoot:ready', identify)
        }
    }, [distributor.data])
}
